import { render, staticRenderFns } from "./view-informes-voluntariado.vue?vue&type=template&id=2e53d047&scoped=true"
import script from "./view-informes-voluntariado.vue?vue&type=script&lang=js"
export * from "./view-informes-voluntariado.vue?vue&type=script&lang=js"
import style0 from "./view-informes-voluntariado.vue?vue&type=style&index=0&id=2e53d047&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e53d047",
  null
  
)

export default component.exports